import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialoglogin";
import { useState, useEffect } from "react";
import SignupForm from "./SignInForm";
import PasswordReset from "./PasswordReset/PasswordReset";
import LoginForm from "./LoginForm";

interface LoginDialogProps {
  trigger?: React.ReactNode;
  initialActiveButton?: string;
  open?: boolean;
  onClose?: () => void;
}

const LoginDialog = ({
  trigger,
  initialActiveButton,
  open,
  onClose,
}: LoginDialogProps) => {
  const [activeButton, setActiveButton] = useState(initialActiveButton);
  const [isPasswordReset, setPasswordReset] = useState(false);

  const handleCloseDialog = () => {
    // Reset the password reset state when the loginDialog is closed
    setPasswordReset(false);
  };
  const [isOpen, setIsOpen] = useState(false); // State to control open/close of modal

  const closeDialog = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  useEffect(() => {
    if (open) setIsOpen(true);
  }, [open]);

  useEffect(() => {
    if (onClose && !isOpen) {
      onClose();
    }
  }, [isOpen, onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        onClose={handleCloseDialog}
        className={`max-w-[472px] bg-[#0842B0]/70 text-white/30`}
      >
        {isPasswordReset ? (
          <PasswordReset />
        ) : (
          <div className="flex w-full flex-col rounded-l-lg text-white">
            <div className="mb-4 text-center text-[24px] font-[500]">
              {activeButton === "login"
                ? "Login to Sharkroll"
                : "Sign Up  to Sharkroll"}
            </div>

            <svg
              className="m-auto"
              width="325"
              height="1"
              viewBox="0 0 424 1"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line opacity="0.2" y1="0.5" x2="424" y2="0.5" stroke="#69EAFF" />
            </svg>

            <div className="mb-1 mb-2 mt-2 flex items-center gap-4">
              <Button
                variant="underline"
                className={`flex-grow ${
                  activeButton === "login"
                    ? "text-white"
                    : "border-white/50 text-white/50"
                }`}
                onClick={() => setActiveButton("login")}
              >
                LOGIN
              </Button>
              <Button
                variant="underline"
                className={`flex-grow ${
                  activeButton === "signup"
                    ? "text-white"
                    : "border-white/50 text-white/50"
                }`}
                onClick={() => setActiveButton("signup")}
              >
                SIGN UP
              </Button>
            </div>
            {activeButton === "login" ? (
              <LoginForm
                setPasswordReset={setPasswordReset}
                onClose={closeDialog}
              />
            ) : (
              <SignupForm onClose={closeDialog} />
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LoginDialog;
